module.exports = __webpack_public_path__ + "static/media/diet-fresh-fruit-svgrepo-com.691d47d7.svg";